const MarketingConsentTypes = {
	Email: 1,
	Post: 2,
	SMS: 3,
	Telephone: 4,
	RaildaysNotification: 5
};

const getLabel = value => {
	switch (value) {
		case MarketingConsentTypes.Email:
			return "Email";
		case MarketingConsentTypes.Post:
			return "Post";
		case MarketingConsentTypes.SMS:
			return "SMS";
		case MarketingConsentTypes.Telephone:
			return "Telephone";
		case MarketingConsentTypes.RaildaysNotification:
			return "Raildays Push Notification";
		default:
			return "Unknown";
	}
};

export default MarketingConsentTypes;
export {MarketingConsentTypes as values, getLabel};
